import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebBrowser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 24,
	viewBox: "0 0 20 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3185 23L11.8371 17.2548M11.8371 17.2548L9.09891 19.7751L9.71964 9.04809L15.4218 18.016L11.8371 17.2548ZM10 1V3.54866M16.3644 3.73669L14.6287 5.53887M19 10.3451H16.5455M5.37127 15.1513L3.63673 16.9523M3.45455 10.3451H1M5.37127 5.53887L3.63673 3.73782",
		stroke: "#454CFC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWebBrowser;
